module.exports = __webpack_public_path__ + "static/wl_logo-mob-52df59b83637c0e51bdb37a850b6bb6c.png";